import Vue from 'vue';
import VueI18n from 'vue-i18n';
import user_event_landing from '@/modules/UserEventLanding/pluralization';
import event_data from '@/modules/Events/pluralization';
import notifications from '@/modules/Notification/pluralization';
import { I18N_KEY } from '@/constants/I18n';
import { ROLES } from '@/constants/roles';

VueI18n.prototype.getChoiceIndex = function (choice) {
  // this === VueI18n instance, so the locale property also exists here
  if (choice % 10 === 1 && choice % 100 !== 11) {
    return 0;
  }
  if (choice % 10 >= 2 && choice % 10 <= 4 && (choice % 100 < 10 || choice % 100 >= 20)) {
    return 1;
  }
  return 2;
};

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'ru',
});

i18n.setLocaleMessage('ru', {
  [I18N_KEY.stages]: ' {count} этап | {count} этапа | {count} этапов',
  [I18N_KEY.years]: ' {count} год | {count} года | {count} лет',
  [I18N_KEY.months]: ' {count} месяц | {count} месяца | {count} месяцев',
  [I18N_KEY.days]: ' {count} день | {count} дня | {count} дней',
  [I18N_KEY.hours]: ' {count} час | {count} часа | {count} часов',
  [I18N_KEY.minutes]: ' {count} минута | {count} минуты | {count} минут',
  [I18N_KEY.waitingTimeLessThanMinute]: 'меньше минуты',
  [I18N_KEY.seconds]: ' {count} секунда | {count} секунды | {count} секунд',
  [I18N_KEY.newWord]: ' {count} новая | {count} новые | {count} новых',
  [I18N_KEY.works]: ' {count} работа | {count} работы | {count} работ',
  [I18N_KEY.members]: ' {count} участник | {count} участника | {count} участников',
  [I18N_KEY.money]: ' {count} рубль | {count} рубля | {count} рублей',
  [I18N_KEY.events]: ' {count} мероприятие | {count} мероприятия | {count} мероприятий',
  [I18N_KEY.requests]: {
    score: {
      basic: 'заявка | заявки | заявок',
      dative: 'заявку | заявки | заявок',
      direct: 'Ваша заявка направлена | Ваши заявки направлены',
      cancel: 'Ваша заявка отменена | Ваши заявки отменены',
    },
    count: ' {count} заявка | {count} заявки | {count} заявок',
  },
  [I18N_KEY.voteWorkScore]: 'балл | балла | баллов',
  [I18N_KEY.voteResultScore]: 'голос | голоса | голосов',

  [I18N_KEY.userEventLanding]: user_event_landing,
  [I18N_KEY.eventData]: event_data,
  [I18N_KEY.notifications]: notifications,
  [I18N_KEY.nomination]: {
    score: {
      basic: 'номинация | номинации | номинаций',
      accusative: 'номинацию | номинации | номинаций',
    },
    count: {
      basic: '{count} номинация | {count} номинации | {count} номинаций',
      accusative: '{count} номинацию | {count} номинации | {count} номинаций',
    },
  },
  [I18N_KEY.category]: {
    score: {
      basic: 'категория | категории | категорий',
      accusative: 'категорию | категории | категорий',
    },
    count: {
      basic: '{count} категория | {count} категории | {count} категорий',
      accusative: '{count} категорию | {count} категории | {count} категорий',
    },
  },
  [I18N_KEY.question]: {
    score: {
      basic: 'вопрос | вопроса | вопросов',
      accusative: 'вопрос | вопроса | вопросов',
    },
    count: {
      basic: '{count} вопрос | {count} вопроса | {count} вопросов',
      accusative: '{count} вопрос | {count} вопроса | {count} вопросов',
    },
  },
  [I18N_KEY.value]: {
    score: {
      basic: 'значение | значений',
      accusative: 'значение | значения | значений',
    },
    count: {
      basic: '{count} значение | {count} значений',
      accusative: '{count} значение | {count} значения | {count} значений',
    },
  },
  [I18N_KEY.correctAnswer]: {
    score: {
      basic: 'правильный вариант ответа | правильных варианта ответа | правильных вариантов ответа',
      accusative: 'правильный вариант ответа | правильных варианта ответа | правильных вариантов ответа',
    },
    count: {
      basic: '{count} правильный вариант ответа | {count} правильных варианта ответа | правильных вариантов ответа',
      accusative: '{count} правильный вариант ответа | {count} правильных варианта ответа | правильных вариантов ответа',
    },
  },
  [I18N_KEY.point]: {
    score: {
      basic: 'балл | балла | баллов',
      accusative: 'балл | балла | баллов',
    },
    count: {
      basic: '{count} балл | {count} балла | {count} баллов',
      accusative: '{count} балл | {count} балла | {count} баллов',
    },
  },
  [I18N_KEY.roles]: {
    [ROLES.organization]: 'организация | организации | организаций',
    [ROLES.certificate]: 'сертификат | сертификата | сертификатов',
    [ROLES.department]: 'департамент | департамента | департаментов',
    [ROLES.operator]: 'оператор | оператора | операторов',
    [ROLES.member]: 'участник | участника | участников',
    [ROLES.expert]: 'эксперт | эксперта | экспертов',
    [ROLES.admin]: 'администратор | администратора | администраторов',
    [ROLES.trainer]: 'наставник | наставника | наставников',
    [ROLES.moderator]: 'модератор | модератора | модераторов',
    [ROLES.event_manager]: 'event-менеджер | event-менеджера | event-менеджеров',
    [ROLES.guest]: 'гость | гостя | гостей',
  },
  [I18N_KEY.participation]: 'участие | участия | участий',
  [I18N_KEY.tasks]: {
    score: {
      basic: 'задание | задания | заданий',
    },
    count: {
      basic: '{count} задание | {count} задания | {count} заданий',
    },
  },
});

export default i18n;
